import React, { useState } from 'react';

import { Link, useParams } from 'react-router-dom';

import { RenderCardInfo } from './RenderCardInfo';

import { Breadcrumb, BreadcrumbItem } from '../../Breadcrumb';

export const AddCardPayment = () => {
  const { id: loadId } = useParams();
  return (
    <div className="card-info-wrapper">
      <div className="fields-wrapper">
        <Breadcrumb>
          <BreadcrumbItem className="breadcrumbItem">
            <Link to={`/dashboard`}>Dashboard</Link>
          </BreadcrumbItem>
          <BreadcrumbItem className="breadcrumbItem">
            <Link to={`/account/${loadId}`}>{`Loan #${loadId}`}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem className="breadcrumbItem">Add card</BreadcrumbItem>
        </Breadcrumb>

        <h1 className="title">
          Loan #{loadId}
          <br />
          {'Add a Payment Instrument'}
        </h1>

        <RenderCardInfo />
      </div>
    </div>
  );
};
